export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-background-100 to-background-200/50 rounded-2xl border border-background-200/70 p-8 md:p-12 text-center">
          <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-50 flex items-center justify-center mx-auto">
            <i className="ri-mail-send-line text-2xl md:text-3xl text-primary-500"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mt-6">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto leading-relaxed">
            如果您有<strong className="text-foreground-700">吃瓜视频</strong>线索、投稿或合作意向，
            欢迎通过以下方式联系51暗网吃瓜团队。我们重视每一条来自<strong className="text-foreground-700">51吃瓜在线</strong>社区的建议和反馈。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
            <div className="flex items-center gap-3 bg-background-50 rounded-xl px-5 py-3 border border-background-200/70">
              <i className="ri-mail-line text-primary-500 text-lg"></i>
              <span className="text-sm text-foreground-600">contact@51angua.example.com</span>
            </div>
            <div className="flex items-center gap-3 bg-background-50 rounded-xl px-5 py-3 border border-background-200/70">
              <i className="ri-telegram-line text-primary-500 text-lg"></i>
              <span className="text-sm text-foreground-600">@51anguachigua</span>
            </div>
          </div>

          <p className="text-xs text-foreground-400 mt-6">
            投稿内容将按<strong className="text-foreground-500">暗网吃瓜视频</strong>审核标准处理，确保品质与安全
          </p>
        </div>
      </div>
    </section>
  );
}